import _ from 'lodash'
import { asyncRoutes, constantRoutes } from '@/router'
import asyncRoutesMap from '@/router/asyncRoutesMap'

/**
 * Use meta.role to determine if the current user has permission
 * @param roles
 * @param route
 */
function hasPermission(roles, route) {
  if (route.meta && route.meta.roles) {
    return roles.some(role => route.meta.roles.includes(role))
  } else {
    return true
  }
}

/**
 * Filter asynchronous routing tables by recursion
 * @param routes asyncRoutes
 * @param roles
 */
export function filterAsyncRoutes(routes, roles) {
  const res = []

  routes.forEach(route => {
    const tmp = { ...route }
    if (hasPermission(roles, tmp)) {
      if (tmp.children) {
        tmp.children = filterAsyncRoutes(tmp.children, roles)
      }
      res.push(tmp)
    }
  })

  return res
}

/**
 * 获取路由配置
 * @param routes 本地路由配置
 * @param role_menus 角色路由
 */
export function mapAsyncRoutes(routes, role_menus) {
  let res = []
  let isConcatHiddenRoutes = false

  role_menus.forEach(menu => {
    const tmp = {
      name: menu.name,
      path: menu.path
    }

    const filter = routes.filter(route => {
      return route.path.indexOf(tmp.path) === 0
    })

    if (filter[0]) {
      // 防止数据有错误
      const { children, ...routerSetting } = filter[0]

      // console.log('===routerSetting', routerSetting, menu)
      if (menu.children) {
        // 数据返回菜单的有children
        routerSetting.children = mapAsyncRoutes(children, menu.children)
      } else if (children) {
        // 数据返回的菜单没有children 但是本地有, 则把hidden的菜单加进去
        routerSetting.children = children.filter(child => child.hidden)
      }
      res.push(routerSetting)
    }

    if (!isConcatHiddenRoutes) {
    // 加入隐藏的、非菜单同级路由
      const hiddenRoutes = routes.filter(route => {
        return !!route.hidden
      })

      // console.log('hiddenRoutes', hiddenRoutes)
      res = res.concat(hiddenRoutes)
      isConcatHiddenRoutes = true
    }
  })
  // console.log('=====routes', res)
  return res
}

/**
 * 获取菜单路由
 * @param routes 路由
 */
export function filterMenuRoutes(routes, disabled) {
  const res = []

  routes.forEach(route => {
    const tmp = { ...route }
    if (tmp.is_menu) {
      if (tmp.children) {
        tmp.children = filterMenuRoutes(tmp.children, disabled)
      }
      tmp.disabled = disabled
      res.push(tmp)
    }
  })

  return res
}

export function getRoutesRedirect(routes) {
  // 所有一级一步菜单栏 重写重定向地址
  return routes.map(route => {
    const children0 = _.get(route, ['children', '0'])
    if (children0) {
      route.redirect = route.path + '/' + children0.path
    }
    return route
  })
}

const state = {
  routes: [],
  addRoutes: []
}

const mutations = {
  SET_ROUTES: (state, routes) => {
    state.addRoutes = routes
    state.routes = constantRoutes.concat(routes)
  }
}

const actions = {
  generateRoutes({ commit }, role_menus) {
    return new Promise(resolve => {
      const _asyncRoutes = asyncRoutesMap
      console.log(_asyncRoutes, role_menus)
      let routes = mapAsyncRoutes(_asyncRoutes, role_menus)
      routes = getRoutesRedirect(routes)
      // console.log('=======froutes', routes)
      const accessedRoutes = [...routes, ...asyncRoutes]
      accessedRoutes.unshift({
        path: '/',
        redirect: accessedRoutes[0].path
      })
      // console.log('===', accessedRoutes)
      commit('SET_ROUTES', accessedRoutes)
      resolve(accessedRoutes)
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
